export function IslandFooter() {
  return (
    <footer className="coast-footer" aria-label="摸鱼岛页脚">
      <svg
        className="coast-footer-landscape"
        viewBox="0 0 1600 180"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path
          className="coast-far"
          d="M0 25C85 3 137 62 218 77S330 73 402 105S505 77 593 115S740 130 812 113S905 140 997 108S1109 63 1200 102S1304 115 1370 128S1508 105 1600 94V180H0Z"
        />
        <path
          className="coast-middle"
          d="M0 70C95 109 173 63 263 112S378 141 458 132S537 117 609 140S724 147 812 132S954 157 1039 139S1171 112 1260 142S1426 110 1511 133S1574 123 1600 116V180H0Z"
        />
        <path
          className="coast-water"
          d="M0 145C113 139 176 153 270 147S391 146 480 151S659 144 757 150S932 144 1040 151S1221 144 1330 150S1478 138 1600 148V180H0Z"
        />
      </svg>
      <svg className="coast-footer-island" viewBox="0 0 360 155" aria-hidden="true">
        <g fill="currentColor">
          <path d="M0 138C30 142 44 125 62 123C77 98 109 96 137 112C151 108 163 115 173 123C195 119 214 132 238 132L295 132L324 145H0Z" />
          <path d="M107 113C111 91 116 69 130 41L135 42C122 74 121 95 119 115Z" />
          <path d="M130 43C108 41 104 55 106 65C114 51 121 53 130 47C114 67 120 76 125 79C124 63 132 56 136 45C146 51 150 61 151 69C161 49 148 40 138 40C155 31 164 35 174 46C172 23 151 23 135 36C139 17 128 11 119 15C128 22 130 26 131 36C117 21 106 23 100 31C115 28 119 34 130 43Z" />
          <path d="M77 117C78 97 77 86 73 70L77 68C85 91 86 103 86 118Z" />
          <path d="M74 72C61 63 50 69 49 79C59 73 64 75 71 75C58 76 55 86 59 93C63 82 69 79 76 76C83 82 86 88 87 94C94 82 84 72 79 72C91 64 99 69 103 77C107 59 87 58 77 68C80 57 75 51 68 53C73 59 72 63 74 72Z" />
          <path d="M232 132L240 69H252L260 132Z" />
          <path d="M237 72H256V66H237Z" />
          <path d="M240 64V51H253V64H249V54H244V64Z" />
          <path d="M235 51L246 43L258 51Z" />
          <path d="M245 45V37H248V45Z" />
          <path d="M234 65H259V68H234Z" />
          <path d="M144 113C146 102 153 102 157 108L164 116L152 115Z" />
        </g>
        <g fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
          <path d="M189 96Q183 86 176 87Q183 84 188 89Q191 79 198 79" />
          <path d="M17 151Q44 147 76 151M125 148Q153 151 174 148M222 151H284" opacity=".45" />
        </g>
      </svg>
      <svg
        className="coast-footer-birds"
        viewBox="0 0 1600 180"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <g fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
          <path d="M644 81Q650 75 656 81Q660 73 668 74M1119 60Q1125 54 1131 60Q1137 53 1144 57" />
        </g>
      </svg>
      <div className="coast-footer-brand">
        <span>MOYU ISLAND</span>
        <p>上岛摸鱼，快乐开局。</p>
      </div>
      <div className="coast-footer-note">
        <p>
          工作是生活的一部分
          <br />
          <span>快乐才是主线</span>
        </p>
        <svg viewBox="0 0 40 40" aria-hidden="true">
          <path d="M29 6C14 0 3 13 6 26C10 42 34 35 35 18M15 15L14 18M25 12L24 15M13 24Q22 30 28 21" />
        </svg>
      </div>
    </footer>
  );
}
